import React, { useMemo, useState } from 'react'
import { Flex } from 'reflexbox'
import { useParams } from 'react-router-dom'

import { toast } from 'react-toastify'

import { Title } from 'components/Typography'
import Breadcrumb from 'components/Breadcrumb'
import Button from 'components/Button'
import Loader from 'components/Loader'

import GiftCardConsumptionList from 'containers/GiftCardComsumptionList'

import { exportCSV } from 'services/giftCards'
import { download } from 'helpers/download'

const GiftCardsOrdesHistory = () => {
  const [isDownloading, setIsDownloading] = useState(false)
  const { id: orderId } = useParams()

  const breadcrumbPath = useMemo(
    () => [
      {
        label: 'Cartões presente',
        link: '/prepaid-purchase/gift-cards',
      },
      {
        label: `Pedido ${orderId}`,
        link: `/prepaid-purchase/gift-cards/order/${orderId}`,
      },
      {
        label: 'Lista de cartões presente',
      },
    ],
    [orderId],
  )

  const getCsv = async () => {
    try {
      setIsDownloading(true)
      const { data } = await exportCSV(orderId)

      download(data, 'guigo_gift_cards')
    } catch (e) {
      console.log(e)
      toast.error('Aconteceu um erro ao export o arquivo CSV, por favor tente novamente.')
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <Flex flexDirection='column'>
      <Breadcrumb children={breadcrumbPath} />
      <Flex alignItems='center' justifyContent='space-between'>
        <Title as='h3'>Lista de cartões presente</Title>
        <Button size='big' onClick={getCsv} disabled={isDownloading}>
          {isDownloading ? <Loader /> : 'Download CSV'}
        </Button>
      </Flex>

      <GiftCardConsumptionList />
    </Flex>
  )
}

export default GiftCardsOrdesHistory
